export const ontimeAlertOnDark = {
  container: {
    fontSize: 'calc(1rem - 1px)',
    backgroundColor: '#1a1a1a', // $gray-1300
    color: '#e2e2e2', // $gray-200
    borderRadius: '3px',
  },
  icon: {
    alignSelf: 'start',
    color: '#578AF4', // $blue-500
  },
};

export const ontimeDialog = {
  container: {
    backgroundColor: '#1a1a1a', // $gray-1300
    color: '#e2e2e2', // $gray-200
    borderRadius: '3px',
  },
};
